// @flow
import styled from 'styled-components';

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0px;
  text-align: center;
`;

const TableRow = styled.tr`
  border-bottom: 1px solid rgb(182, 182, 180);
  color: rgb(33, 33, 33);
`;

const TableBody = styled.tbody`
  tr {
    height: 48px;
  }

  tr:last-child {
    border-bottom: none;
  }
`;

const TableHeader = styled.thead`
  font-weight: normal;

  tr {
    height: 56px;
  }

  tr:last-child {
    border-bottom: none;
  }

  td {
    padding-left: 16px;
    padding-right: 16px;
  }
`;

export const Cell = styled.td`
  font-size: ${({ theme }) => theme.fonts.style.midSmall.fontSize}px;
  font-weight: 300;
  color: ${({ theme }) => theme.colors.primaryText};
  padding: 0 ${({ theme }) => theme.metrics.margin}px;
`;


export const HeaderText = styled(Cell)`
  font-size: ${({ theme }) => theme.fonts.style.tableHeader.fontSize}px;
  color: ${({ theme }) => theme.fonts.style.tableHeader.color};
  opacity: ${({ theme }) => theme.fonts.style.tableHeader.opacity};
  font-weight: bolder;
`;


export { Table, TableRow, TableBody, TableHeader };



// WEBPACK FOOTER //
// ./src/common/components/Tables.js